import React from 'react'
import { useParams } from 'react-router-dom'
import { UserLayout } from 'components/layout/UserLayout'
import { FullPageHeader } from 'components/layout/FullPageLayout/Header/FullPageHeader'
import { FullPageContent } from 'components/layout/FullPageLayout/Content/FullPageContent'
import { usePacketFonts } from './usePacketFonts'

export function ViewSprintPacket() {
  usePacketFonts()
  const { businessID } = useParams<{ businessID: string; packetID: string }>()
  return (
    <UserLayout>
      <FullPageHeader
        breadcrumbs={[
          { title: 'Sprint Packets', route: `/${businessID}/sprint-packets` },
          { title: 'View' },
        ]}
      />
      <FullPageContent />
    </UserLayout>
  )
}
